/*
 * @Author: zhechuan.Wang
 * @Date: 2023-11-20 11:14:40
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2023-12-07 17:13:00
 * @Description: file content
 * @FilePath: \gfmis-card-ppt\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// element-ui 样式库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'xe-utils';

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
